const products = state => state.products
const page = state => state.page
const filter = state => state.filter
const totalCount = state => state.totalCount
const themes = state => state.themes
const title = state => state.title
const pageSize = state => state.pageSize
const available_tags = state => state.available_tags
// const minNights = state => state.filter.minNights
// const maxNights = state => state.filter.maxNights
// const minPrice = state => state.filter.minPrice
// const maxPrice = state => state.filter.maxPrice

export default {
  products,
  filter,
  page,
  totalCount,
  themes,
  title,
  pageSize,
  available_tags,
  // minNights,
  // maxNights,
  // minPrice,
  // maxPrice,
}
